import { HeaderData } from "../interfaces.ts/interfaces";

export const headerData: HeaderData = {
    title: 'Marion Lintz',
    urls: [{
        name: 'Qui suis-je ?',
        link: '/aboutme'
    },
    {
        name: 'Mes projets',
        link: '/projects'
    },
    {
        name: 'Me contacter',
        link: '/contact'
    }
],
}